export enum InformationStatus {
  Success = 'success',
  Warning = 'warning',
  Danger = 'danger',
  Information = 'information'
}
